import type { HelpStateItem } from '../interfaces';
import { API } from '@Providers';

export default async function (payload: HelpStateItem) {
  const endpoint = '/api/shelter/help-state/remove';

  return API({ endpoint, method: 'post', payload });
}
